module.exports = __webpack_public_path__ + "static/media/2-Break-The-Cycle-Cover.7298077d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/2-Break-The-Cycle-Cover.jpg
// module id = 135
// module chunks = 0